import axios from 'axios';
import React, { useCallback } from 'react'
import { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form } from 'reactstrap';
import AddPocModal from '../../../../components/Modal/AddPocModal';
import DocUploadModal from '../../../../components/Modal/DocUploadModal';
import TenantGalaModal from '../../../../components/Modal/TenantGalaModal';
import { debounce } from "lodash";
import Table from '../../../../components/Table';
import TenantGalasView from './TenantGalasView';
import { environment } from '../../../../env';
import { loaderAction, successModalToggle, warningModalToggle } from '../../../../redux/actions/Index';
import { Link } from 'react-router-dom';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import SuccessPopups from './../../../../components/Popups/SuccessPopups';
import WarningPopup from './../../../../components/Popups/WarningPopup';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Eye, Trash } from '@phosphor-icons/react';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import PathName from '../../../../components/PathName/PathName';
import { ArrowSquareLeft, ArrowSquareRight } from 'iconsax-react';

const SoldGalas = () => {

  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const soldGalaList = useSelector((state) => state?.ModalReducer?.soldGalaList);
  const galaList = useSelector((state) => state?.ModalReducer?.galaList);
  const user = useSelector((state) => state?.Reducers?.userdata);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);

  const [tenantdetails, setTenantDetails] = useState([]);
  const [selproject, setSelProject] = useState();
  const [btot, setBTot] = useState();
  const [btotaltot, setBTotaltotal] = useState();
  const [ptot, setpTot] = useState();
  const [ptotaltot, setpTotaltotal] = useState();
  const [proposals, setProposals] = useState([]);
  const [proposalfil, setProposalfil] = useState([]);
  const [emptyfilter, setEmptyfilter] = useState(false);
  const [tenantfilter, setTenantFilters] = useState([]);
  const [filterBuilding, setFilterBuilding] = useState([]);
  const [update, setUpdate] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [records, setRecords] = useState(10);
  const [loading, setLoading] = useState(false);
  const [nextIsValid, setNextIsValid] = useState(false);
  const [prevIsValid, setPrevIsValid] = useState(false);

  const dispatch = useDispatch()

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm()

  var selectedBuildingId = watch("building");
  var selectedProposal = watch("proposal");

  const dateDiffInDataHandeler = (date1) => {
    date1 = moment(date1);
    let date2 = moment().format('YYYY-MM-DD');
    let days = date1.diff(date2, 'days')
    if (days > 0) return false;
    return true;
  }

  const debounce = useCallback(
    _.debounce((_searchVal) => {
      SGFilterCallPageChange(1,undefined,_searchVal)
    }, 600),
    []
  );

  const getTenant = async (data) => {
    dispatch(loaderAction(true))
    try {
      await axios.get(`${environment.baseUrl}add-gala-tenant/`).then((customerdata) => {
        let dataa = customerdata.data.filter((data) => {
          if (data.project.id == userProject) {
            if (data.terminate == true && data.status == "Vacated") {
              return false;
            }
            return true;
          } else {
            return false;
          }
        })
        setTenantDetails(dataa);
        setEmptyfilter(false)
        dispatch(loaderAction(false))
      })
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }

  useEffect(() => {
    setTenantDetails(tenantdetails)
  }, [tenantdetails])

  const deletetenantData = (id) => {
    dispatch(warningModalToggle(id));
  };

  const deleteData = (id) => {
    dispatch(loaderAction(true))
    dispatch(warningModalToggle(id))
    axios.delete(`${environment.baseUrl}edit-gala-tenant/${id}`).then(res => {
      if (res.data.code === 200) {
        dispatch(loaderAction(false))
        dispatch(successModalToggle())
        getTenant()
        getProposals()
        SGFilterCallPageChange(1, undefined)
      }
      else if (res.data.code === 5005) {
        dispatch(loaderAction(false))
        toast.error(res.data.message, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    })
      .catch(res => {
        dispatch(loaderAction(false))
        console.log("error");
      })
  };

  const getProposals = async (data) => {
    dispatch(loaderAction(true))
    try {
      await axios.get(`${environment.baseUrl}proposal/`).then((proposal) => {
        setProposals(proposal.data);
        dispatch(loaderAction(false))
      })
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }

  useMemo(() => {
    if (selectedBuildingId == '' && userProject == '' && selectedProposal == '') {
      if (tenantdetails?.length >= 0) {
        setEmptyfilter(false)
      } else {
        setEmptyfilter(true)
      }
      setTenantFilters([])
    }
  }, [selectedBuildingId, userProject, selectedProposal, buildingList])

  const clearFilter = () => {
    reset({
      "project": "",
      "building": "",
      "proposal": "",
    })
    if (selectedBuildingId.length > 0 || userProject > 0 || selectedProposal.length > 0) {
      toast.success('Filter Clear Successfully !', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      });
    }
    SGFilterCallPageChange(1, undefined)
  }
  const columns = [
    {
      name: 'Status',
      selector: row => <div className="d-flex justify-content-between align-items-center gap-2 " >
        <label className={`${row.status === "Occupied" && 'icon-bg-green icon-color-green '} ${row.status === "Partially" && 'icon-bg-yellow icon-color-yellow'} ${(row.status == 'Vacated' || (row.terminate && dateDiffInDataHandeler(row.terminate_date)) == true) && 'icon-bg-red icon-color-red'} ounded-pill status-box rounded fs-4`}>{row.terminate == true ? (dateDiffInDataHandeler(row.terminate_date) ? "Terminated" : row.status) : row?.status}</label>
      </div>,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Tenant Name',
      selector: row => row.proposal.name_of_company,
      wrap: true,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Building',
      selector: row => row.building.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Area',
      selector: row => (row.proposal.required_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Aggreement Start Date',
      selector: row => moment(row.aggrement_start_date).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Aggreement End Date',
      selector: row => moment(row.aggrement_end_date).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Rent End Date',
      selector: row => moment(row.rent_end_date).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Action',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <Link to={`/TenantGala/${row.id}`} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></Link>
        {user?.role != 'user' && <TenantGalaModal button={'edit'} data={row} proposalsProp={proposals} updateListHandler={afterUpdateHandler} />}
        {user?.role == 'superadmin' && <button onClick={() => deletetenantData(row.id)} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>}
      </div>,
    },

    {
      name: 'POC',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <AddPocModal tenant={row?.id} ttenant={true} />
      </div>,
    },
    {
      name: 'Upload',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <DocUploadModal type={"tenantgala"} data={row} />
      </div>,
    },
  ]

  const column = [
    {
      name: 'Status',
      selector: row => { row.terminate == true ? (dateDiffInDataHandeler(row.terminate_date) ? "Terminated" : row.status) : row?.status },
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Tenant Name',
      selector: row => row.proposal.name_of_company,
      wrap: true,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Building',
      selector: row => row.building.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Area',
      selector: row => (row.proposal.required_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Aggreement Start Date',
      selector: row => moment(row.aggrement_start_date).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Aggreement End Date',
      selector: row => moment(row.aggrement_end_date).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Rent End Date',
      selector: row => moment(row.rent_end_date).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Action',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <Link to={`/TenantGala/${row.id}`} className="icon-bg-green border-0 px-2 py-3 rounded" > <Eye size="28" className='icon-color-green' /></Link>
        {user?.role != 'user' && <TenantGalaModal button={'edit'} data={row} proposalsProp={proposals} updateListHandler={afterUpdateHandler} />}
        {user?.role == 'superadmin' && <button onClick={() => deletetenantData(row.id)} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>}
      </div >,
    },
    {
      name: 'POC',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <AddPocModal tenant={row?.id} ttenant={true} />

      </div>,
    },
    {
      name: 'Upload',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <DocUploadModal type={"tenantgala"} data={row} />
      </div>,
    },
  ]

  useEffect(() => {
    SGFilterCallPageChange(1, undefined)
    getProposals()
    getTenant()
    setTenantFilters([])
  }, [userProject])

  const afterUpdateHandler = () => {
    SGFilterCallPageChange(1, undefined)
    getProposals()
    getTenant()
    setTenantFilters([])
  }

  useMemo(() => {
    if (userProject) {
      var projectBuilding = buildingList?.filter((filterBuilding) => filterBuilding.project.id == userProject);
      setFilterBuilding(projectBuilding);
      reset({ "building": "", "proposal": "", "project": userProject })
      var project = projectList?.filter(filter => filter.id == userProject)
      setSelProject(project)
    }
  }, [userProject, buildingList])

  const selectedbuilding = (value) => {
    if (value) {
      var proposalList = proposals?.filter((proposal) => proposal.building_no.building_no == value && proposal.agree_created == true)
      setProposalfil(proposalList)
    } else {
      setProposals(proposalList)
    }
  }


  const SGFilterCallPageChange = async (localPage, localRecord,tenant) => {
    let project = userProject
    var selectedBuildingId = watch("building");
    selectedbuilding(selectedBuildingId);
    var selectedProposal = watch("proposal");
    selectedProposal = tenant ? tenant : selectedProposal
    let SearchUrl = "";
    if (localPage == undefined) {
      SearchUrl = `${environment.baseUrl}/tenant-pagination-filter/?proposal=${selectedProposal ? selectedProposal : ''}&building=${selectedBuildingId ? selectedBuildingId : ''}&project=${userProject}&terminate=&status=&p=1&records=${localRecord}`;
    } else if (localRecord == undefined) {
      SearchUrl = `${environment.baseUrl}/tenant-pagination-filter/?proposal=${selectedProposal ? selectedProposal : ''}&building=${selectedBuildingId ? selectedBuildingId : ''}&project=${userProject}&terminate=&status=&p=${localPage}&records=${records}`;
    }
    setLoading(true);
    const result = await axios(SearchUrl).then((res) => {
      if (res?.data?.next != null && nextIsValid != true) {
        setNextIsValid(true)
      } else if (res?.data?.next == null && nextIsValid != false) {
        setNextIsValid(false)
      }
      if (res?.data?.previous != null && prevIsValid != true) {
        setPrevIsValid(true)
      } else if (res?.data?.previous == null && prevIsValid != false) {
        setPrevIsValid(false)
      }
      if (res?.data?.results.length > 0) {
        const dat = res?.data?.results
        if (dat.length != 0) {
          setTenantFilters(dat)
          setEmptyfilter(false)
          if (selectedBuildingId != undefined && selectedBuildingId != '') {
            setBTot(res.data.rented)
            setBTotaltotal(res.data.available)
          }
          if (userProject != undefined && userProject != '') {
            var totalsold = 0
            soldGalaList?.map(dat => {
              if (dat.project.id == userProject) {
                totalsold = Number(totalsold) + Number(dat.sold_gala_area)
              }
            })
          }
        } else {
          setBTot(res.data.rented)
          setBTotaltotal(res.data.available)
          setEmptyfilter(true);
          dispatch(loaderAction(false))
        }
      } else {
        setBTot(res.data.rented)
        setBTotaltotal(res.data.available)
        setEmptyfilter(true);
      }
      setLoading(false);
    })
  }

  const pageChangeHandler = (LocalPageNo) => {
    if (((pageNo < LocalPageNo) && nextIsValid) || ((pageNo > LocalPageNo) && prevIsValid)) {
      SGFilterCallPageChange(LocalPageNo, undefined) // page change call
      setPageNo(LocalPageNo)
    }
  }

  const recordChangeHandler = (recordSize) => {
    SGFilterCallPageChange(undefined, recordSize) // record change call
    setRecords(recordSize);
    setPageNo(1);
  }

  return (
    <>
      <PathName />
      <ToastContainer />
      <SuccessPopups />
      <WarningPopup deleteData={deleteData} customMessage={"Please Type 'delete' to Delete the current Tenant"} tenant={true} />
      <Form >
        <div className='my-4 row'>
          <div className='col-11 mx-auto mx-md-0 col-md-5 col-lg-5 col-xl-5 pb-3 pt-1'>
            <div className='w-100 mt-1  d-flex gap-3'>
              <input
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                type='search'
                autoComplete='off'
                placeholder='Search Tenant Name...'
                {...register('search', { onChange: (e) => { debounce(e.target.value) } })}
              />
            </div>
            <br />
          </div>
          {/* <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <select
                id="role_type"
                name="role_type"
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                {...register("project", { required: true })}
              >
                <option value="">Project Name</option>
                {projectList?.map((data, i) => {
                  return <option value={data.name} key={i}>{data.name}</option>;
                })}
              </select>
            </div>
            {userProject && ptotaltot != 0 && ptot != 0 && ptotaltot - ptot != 0 && <span className="d-flex align-items-center justify-content-between px-3 py-2">
              <span className="fs-4 text-base-black base-font-bold">T : {ptotaltot}</span>
              <span className="fs-4 text-base-black base-font-bold">R : {ptot}</span>
              <span className="fs-4 text-base-black base-font-bold">A : {ptotaltot - ptot}</span>
            </span>}
          </div> */}
          <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <select
                id="role_type"
                name="role_type"
                disabled={!userProject}
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                {...register("building", { required: true, onChange: (e) => { SGFilterCallPageChange(1, undefined) } })}
              >
                <option value="">Building Number</option>
                {filterBuilding?.sort((a, b) => a?.building_no?.localeCompare(b.building_no))?.map((data, i) => {
                  return (
                    <option value={data.building_no} key={i}>{data.building_no}</option>
                  );
                })}
              </select>
            </div>
            {selectedBuildingId &&
              <span className="d-flex align-items-center justify-content-between px-3 py-2"><span className="fs-4 text-base-black base-font-bold">T : {Number(Number(btotaltot) + Number(btot))?.toFixed(2)}</span>
                <br />  <span className="fs-4 text-base-black base-font-bold">R : {Number(btot)?.toFixed(2)}</span>
                <br /><span className="fs-4 text-base-black base-font-bold">A : {Number(btotaltot).toFixed(2)}</span>
              </span>}
            <br />
          </div>
          <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <select
                id="role_type"
                name="role_type"
                disabled={!selectedBuildingId}
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                {...register("proposal", { required: true, onChange: (e) => { SGFilterCallPageChange(1, undefined) } })}
              >
                <option value="">Select Proposal</option>
                {proposalfil?.sort((a, b) => a?.name_of_company?.localeCompare(b?.name_of_company))?.map((data, i) => {
                  return (
                    <option value={data?.name_of_company} key={i}>{data?.name_of_company}</option>
                  );
                })}
              </select>
            </div>
            {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
            <br />
          </div>
          <div className='col-11 mx-auto mx-md-0 col-md-1 col-lg-1 col-xl-1 pb-3 pt-1'>
            <button type="button" className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary" onClick={clearFilter}><span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">Clear</span></button>
          </div>
        </div>
      </Form>
      
      <div className="bg-white p-4 p-md-4 p-lg-5 p-xl-5 d-flex gap-5 flex-column rounded-5 mt-1 mb-5">
        <div className="">
          <div className='d-flex justify-content-between align-items-center pb-5'>
            <h1 className='title-font-bold '>Tenant (Rented Galas)</h1>
            <TenantGalaModal button={'create'} proposalsProp={proposals} updateListHandler={afterUpdateHandler} />
          </div>
          {emptyfilter ? <EmptyTable /> : tenantfilter.length > 0 && <Table pageinationProp={true} columns={user?.role == "user" ? column : columns} data={tenantfilter} />
          }
          <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
            <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
              {""}
            </div>
            <div className='d-flex mr-2 gap-3 align-items-center justify-content-between'>
              <select
                className="mt-4 p-3 select-width-data-table-wo-pagination title-font-500 fs-2"
                defaultValue={"10"}
                {...register("recordSize", { onChange: (e) => { recordChangeHandler(e.target.value) } })}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>

              </select>
              <span onClick={() => { pageChangeHandler(pageNo - 1) }} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-1 mt-4"><ArrowSquareLeft color='#6271de' size="28" variant="Bold" /></span>
              <span onClick={() => { pageChangeHandler(pageNo + 1) }} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-2 mt-4"><ArrowSquareRight color='#6271de' size="28" variant="Bold" /></span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SoldGalas